import * as React from "react";
import { useSelector } from "react-redux";
import { Container, Grid, Header } from "semantic-ui-react";

import { routeIdSelector as customerIdSelector } from "../../crud/customer/selectors";
import { ApplicationState } from "../../applicationState";
import { GPSpecialistLetterModel } from "../models";
import { generalPractitionerSpecialistApi } from "../gpSpecialistInfoApi";

export const GPSpecialistLetterOld: React.FunctionComponent = () => {

    const customerId = useSelector(customerIdSelector);
    const ohCaseId = useSelector((state: ApplicationState) => state.router.params?.ohCaseId);
    const taskId = useSelector((state: ApplicationState) => state.router.params?.taskId);

    const [letterModel, setLetterModel] = React.useState<GPSpecialistLetterModel | null>(null);

    React.useEffect(() => {
        if (customerId && ohCaseId && taskId) {
            (async () => {
                const model = await generalPractitionerSpecialistApi.getGPSpecialistLetter(customerId, ohCaseId, taskId);
                setLetterModel(model);
            })();
        }
    }, [customerId, ohCaseId, taskId]);

    const footerCustomerCategoryName = React.useMemo(() =>
        letterModel && letterModel.customerCategory.toUpperCase().startsWith("HEALTHWORK")
            ? "Healthwork Group"
            : letterModel?.customerCategory, [letterModel]);

    if (!letterModel) {
        return null;
    }

    return (
        <>
            <Container>
                <Grid className="letter-body">
                    <img src="/assets/myOH Report Banner2.png" />
                    <Grid.Row>
                        <Grid.Column width="8">
                            <Header as="h2">Re: GP/Specialist Letter</Header>
                        </Grid.Column>
                        <Grid.Column width="8" textAlign="right">
                            Private & Confidential
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width="16">
                            <Grid.Row>{letterModel.gpSpecialistName}</Grid.Row>
                            <Grid.Row>{letterModel.gpSpecialistAddress}</Grid.Row>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width="16">
                            <Grid.Row>
                                Ref: {letterModel.employeePersonalReferenceNumber} | Date: {letterModel.letterDate.toLocaleDateString("en-GB")}
                            </Grid.Row>
                            <Grid.Row>
                                Telephone: {letterModel.customerTelephoneNumber} | Email: {letterModel.customerEmailAddress}
                            </Grid.Row>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width="16">
                            <Grid.Row>Dear {letterModel.gpSpecialistName}</Grid.Row>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width="16">
                            <Grid.Row textAlign="left">Name: {letterModel.employeeName}</Grid.Row>
                            <Grid.Row textAlign="left">D.O.B: {letterModel.employeeDateOfBirth}</Grid.Row>
                            <Grid.Row textAlign="left">Address: {letterModel.employeeAddress}</Grid.Row>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width="16">
                            <span className="letter-text">{letterModel.letterText}</span>
                            <p>
                                Yours sincerely,<br />
                                {letterModel.adminUserName}<br />
                                {letterModel.adminUserQualification}
                            </p>
                            <p>
                                <strong>Optima Health</strong> | www.optimahealth.co.uk | 01327 810262 <br />
                                First Floor, Rickyard Barn, Pury Hill Business Park, Nr Alderton, Towcester, Northamptonshire, NN12 7LS <br />
                                <small>
                                    TP Health a subsidiary of <strong>Optima Health Plc. </strong>
                                    Our Registered Office is Meadow Court, 2 Hayland Street, Sheffield, England, S9 1BY.
                                    We are registered in England and Wales with Registered Number 5770728.
                                </small>
                            </p>
                        </Grid.Column>
                        <Grid.Column />
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width="16">
                            Please ensure any invoices submitted are addressed to: <br />
                            { footerCustomerCategoryName } Ltd, T/A Optima Health,
                            First Floor, Rickyard Barn, Pury Hill Business Park, NrAlderton, Towcester, Northamptonshire, NN12 7LS
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        </>
    );
};
